import { render, staticRenderFns } from "./Commnets.vue?vue&type=template&id=bf436e96&"
import script from "./Commnets.vue?vue&type=script&lang=js&"
export * from "./Commnets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports